import { EFormPage } from './e-form-page.model';

export class EFormTab {
    Id: number;
    Name: string;
    Order: number;
    Pages: EFormPage[] = [];
    ParentObjectId: number;
    Condition: string | boolean;
    ConditionalAction: string;
    Visible: boolean;

    // Tree View Property
    Expanded: boolean;
}